import { useCallback } from "react";
import { useEffect, useState } from "react";
import { getAllPartners, getPartnerById, presetsAllPartners } from "../../api/projects";

export function usePartnerListHooks() {
  const [partners, setPartners] = useState([]);
  const [meta, setMeta] = useState({count: 0, page: 1, page_size: 10});
  const [errorMsg, setErrorMsg] = useState('');
  const [loading, setLoading] = useState(false);

  const getPartners = useCallback(async (filter = {}) => {
    setLoading(true);
    setErrorMsg('');
    try {
      const { data } = await getAllPartners({ ...filter });
      setPartners(data.data);
      setMeta(data.pagination);
    } catch (error) {
      if (error.response) {
        let { data } =  error.response;
        setErrorMsg(data.message)
      } else {
        setErrorMsg("Something Error Happened")
      }
    }
    setLoading(false);
  }, []) 

  return {
    partners,
    meta,
    loading,
    errorMsg,
    getPartners
  }
}

export function usePartnerHooks({ id }) {
  let [data, setData] = useState({});
  let [success, setSuccess] = useState(null);
  let [fetched, setFetched] = useState(false);
  let [error, setError] = useState(null);
  let [loading, setLoading] = useState(false);

  useEffect(() => {
    if (id) {
      getVendor(id)
    }
  }, [id]);

  const getVendor = async (id) => {
    setData({});
    setError("");
    setLoading(true);
    setSuccess(null);
    setFetched(false)
    try {
      let response = await getPartnerById(id);
      setData(response.data.data);
      setFetched(true)
    } catch (error) {
      if (error.response) {
        let { data } =  error.response;
        setError(data.message)
      } else {
        setError("Something Error Happened")
      }
    }

    setLoading(false);
  };

  return {
    data,
    fetched,
    success,
    error,
    loading,
    getVendor,
  }
}

export function useAllPartnersHooks() {
  const [partners, setPartners] = useState([]);
  const [errorMsg, setErrorMsg] = useState('');
  const [loading, setLoading] = useState(false);

  const getAllPartners = async () => {
    setLoading(true);
    setErrorMsg('');
    try {
      const { data } = await presetsAllPartners();
      setPartners(data.data);
    } catch (error) {
      if (error.response) {
        let { data } =  error.response;
        setErrorMsg(data.message)
      } else {
        setErrorMsg("Something Error Happened")
      }
    }
    setLoading(false);
  }

  useEffect(() => {
    getAllPartners();
  }, [])

  return {
    partners,
    loading,
    errorMsg,
    getAllPartners
  }
}